<template>
    <transition-group
            v-if="alerts.length"
            appear
            tag="div"
            name="slide-fade"
            class="alerts">
        <v-alert
                v-for="alert in alerts"
                :key="alert.id"
                text
                outlined
                prominent
                dismissible
                :type="alert.type"
                @input="alert.hide()">
            {{ alert.message }}
        </v-alert>
    </transition-group>
</template>

<script>
    export default {
        name: "Alerts",
        computed: {
            alerts() {
                return this.$store.modals.getAlerts();
            },
        }
    }
</script>

<style scoped>
	.alerts {
		top: 0;
		left: 0;
		width: 100vw;
		padding: 16px 16px 0;
		position: fixed;
		z-index: 1000;
		box-sizing: border-box;
	}
	
	.alerts .v-alert {
		background: #fff !important;
	}
	
	.slide-fade-enter-active {
		transition: all .3s ease;
	}
	
	.slide-fade-leave-active {
		transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	
	.slide-fade-enter, .slide-fade-leave-to {
		transform: translateY(-100vh);
		opacity: 0;
	}
</style>